import template from './index.html.twig';

const { Component } = Shopware;

Component.register('sw-postfinancecheckout-settings-icon', {
    template
});
